/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AIConfigTargetingVariationJSON,
  AIConfigTargetingVariationJSON$inboundSchema,
  AIConfigTargetingVariationJSON$Outbound,
  AIConfigTargetingVariationJSON$outboundSchema,
} from "./aiconfigtargetingvariationjson.js";

export type AIConfigTargetingVariationValue =
  | boolean
  | AIConfigTargetingVariationJSON
  | number
  | string;

/** @internal */
export const AIConfigTargetingVariationValue$inboundSchema: z.ZodType<
  AIConfigTargetingVariationValue,
  z.ZodTypeDef,
  unknown
> = z.union([
  z.boolean(),
  AIConfigTargetingVariationJSON$inboundSchema,
  z.number(),
  z.string(),
]);
/** @internal */
export type AIConfigTargetingVariationValue$Outbound =
  | boolean
  | AIConfigTargetingVariationJSON$Outbound
  | number
  | string;

/** @internal */
export const AIConfigTargetingVariationValue$outboundSchema: z.ZodType<
  AIConfigTargetingVariationValue$Outbound,
  z.ZodTypeDef,
  AIConfigTargetingVariationValue
> = z.union([
  z.boolean(),
  AIConfigTargetingVariationJSON$outboundSchema,
  z.number(),
  z.string(),
]);

export function aiConfigTargetingVariationValueToJSON(
  aiConfigTargetingVariationValue: AIConfigTargetingVariationValue,
): string {
  return JSON.stringify(
    AIConfigTargetingVariationValue$outboundSchema.parse(
      aiConfigTargetingVariationValue,
    ),
  );
}
export function aiConfigTargetingVariationValueFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigTargetingVariationValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIConfigTargetingVariationValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigTargetingVariationValue' from JSON`,
  );
}
